import { axiosClient, type IResponse } from '~/common/js/axios';

import { type AxiosRequestConfig  } from 'axios';

interface RequestI<T>{
  data?: T,
  params?: any,
  headers?: any,
}

export interface Crypto {
  crypto: string;
  cryptoFullName: string;
  coinId: string;
  iconUrl: string;
  scale: string; // TODO: 类型应该为number
  price: string;
}

interface CryptoListResponseI {
  cryptoList: Crypto[];
}

interface CryptoListRequest {
  channelType: number;
  currency: string;
  side: 'buy' | 'sell';
}
export function cryptoList_get(options?: RequestI<CryptoListRequest>, overwriteParams?: AxiosRequestConfig<any>){
  return axiosClient<any, IResponse<CryptoListResponseI>>({
    url: '/gw-api/api/fiat-acquirer-backend/v1/crypto-list',
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    params: options?.data ?? {},
  })
}

export interface CryptoShowI {
  crypto: string;
  cryptoFullName: string;
  iconUrl: string;
}

export interface CryptoShowListResponse {
  hotList: CryptoShowI[];
  newList: CryptoShowI[];
}

export function cryptoShowList_get(options?: RequestI<any>, overwriteParams?: AxiosRequestConfig<any>){
  return axiosClient<any, IResponse<CryptoShowListResponse>>({
    url: '/gw-api/api/fiat-acquirer-backend/v1/crypto-show-list',
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    params: options?.data ?? {},
  })
}

interface Currency {
  currency: string; // 货币代码
  maxAmount: string; // 最大限额
  minAmount: string; // 最小限额
  quota: {
    maxAmount: string; // 最大配额
    midAmount: string;
    minAmount: string;
  };
  scale: number;// 货币精度
}

interface currencyList_get_Res_I {
  channelType: number; 
  currencyList: Array<Currency>;
}

interface CurrencyListRequest {
  side: 'buy' | 'sell';
}

export function currencyList_get(options?: RequestI<CurrencyListRequest>, overwriteParams?: AxiosRequestConfig<any>){
  return axiosClient<any, IResponse<currencyList_get_Res_I>>({
    url: '/gw-api/api/fiat-acquirer-backend/v1/currency-list',
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    params: options?.data ?? {},
  })
}
